module.exports = __webpack_public_path__ + "img/h_slot_machine.f6ef8b99.png";